import {
  deleteContractType,
  clearContractTypeAction,
} from 'actions/contracts/contractTypeActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const ContractTypeDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearContractTypeAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteContractType(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this contract type? This can not be
        undone.
      </div>
    </form>
  )
}

export default ContractTypeDelete
